<template>
    <div>
        <div class="additional-images-row">
            <div v-if="total === null || total > 0" class="d-block w-100 search-results-container pt-0 pb-0">
                <loading :loading="loading" :full-page="false"/>
                <nuxt-link :style="{'opacity': `${loading?0:1}`}" target="_blank" class="mb-3 d-block animate-opacity"
                           :to="{ name: 'contributor-album-full', params: {slug: image.contributor.slug, album_slug: image.album.slug, album_id: image.album.id}}"
                >
                    View all {{ total }} files in this Album
                    <b-icon-arrow-right/>
                </nuxt-link>
                <div ref="additionalImageRow" class="additional-images-wrap similar-images-wrap animate-opacity" :style="{'opacity': `${loading?0:1}`}">
                    <stock-image-thumbnail v-for="additionalImage in fetchedImages" :key="additionalImage.id" :image="additionalImage" :show-in-album-link="false" :show-similar-link="false" :size="'small'" @image-loaded="imageLoaded"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Loading from '../global/Loading.vue'
import StockImageThumbnail from '../StockImageThumbnail.vue'

export default {
    name: 'ImagesFromShoot',
    components: {
        StockImageThumbnail,
        Loading
    },
    props: {
        image: {}
    },
    data () {
        return {
            loading: true,
            fetchedImages: null,
            totalLoaded: 0,
            total: null,
            rowHeight: '13rem',
            isImageLoaded: false
        }
    },
    mounted () {
        if (!this.image.album) {
            this.total = 0
        }
    },
    methods: {
        async fetchImages () {
            if (this.image.album) {
                await axios.get(`/stock-images/shoot/${this.image.code}`)
                    .then(rsp => rsp.data)
                    .then((response) => {
                        if (response.images.length > 0) {
                            this.fetchedImages = response.images
                            this.total = response.total
                        } else {
                            this.total = 0
                        }
                    })
                    .finally(() => {
                        this.$emit('loaded')
                    })
            } else {
                this.$emit('loaded')
            }
        },
        imageLoaded () {
            this.totalLoaded = this.totalLoaded + 1

            if (this.totalLoaded === this.fetchedImages.length) {
                this.loading = false
            }
        }
    }
}
</script>
